import matchesType from '../matchesType'
import { ACTION_PATH } from '../../utils'

/**
 * Enhances reducer to reset state when handling a configured action.
 * ```
 * type Reducer = (state: any, action: FSA) => any
 * (...string) => Reducer => Reducer
 * ```
 * @alias module:core
 * @param {...string} types action types that should trigger reset
 * @return {function} redux higher order reducer function
 */
const withReset = (...types) => (reducer) => (state, action) => {
  if (matchesType(action, ...types)) {
    return reducer(undefined, { type: `${ACTION_PATH}/reset` })
  }
  return reducer(state, action)
}

export default withReset
